<template>
    <div id="app" class="panel-constructor invisible"
         :class="{ 'invisible-bg' : (hasRestrictArea && !allowedRestrictArea) || (!isAuth && actionLogin)}">

        <template
                v-if="(hasRestrictArea && !allowedRestrictArea && !isAuth || !isAuth && actionLogin) && membersArea.open_by === 'page'">
            <restrict-area ref="restrictArea" :open_by="this.membersArea.open_by"></restrict-area>
        </template>

        <template v-else-if="hasRestrictArea && !allowedRestrictArea && isAuth">
            <restrict-area ref="restrictArea" :open_by="this.membersArea.open_by"
                           :not_have_permission="!allowedRestrictArea" notHavePermission="true"></restrict-area>
        </template>

        <div id="editor-content" :data-device="device"
             v-else-if="!hasRestrictArea || hasRestrictArea && allowedRestrictArea || hasRestrictArea && membersArea.open_by === 'popup'">

            <component v-for="(element,index) in elements" :key="index" :is="element.name" :config="element.config"
                       :device="device"
                       is_popup="false"
                       :childs="element.childs">
            </component>

            <sweet-modal v-for="(popup, index) in userPopups" :key="'popup' + popup.id" :id="'popup' + popup.id" :ref="'popup' + popup.id"
                         width="100%"  v-on:close="yourHandlerForCloseUserPopup('popup' + popup.id)" v-on:open="yourHandlerForOpenUserPopup('popup' + popup.id)">
                <component v-for="(element,index2) in  JSON.parse(popup.content)" :key="index2" :is="element.name"
                           :is_popup="true"
                           :config="element.config"
                           :childs="element.childs">
                </component>
            </sweet-modal>

            <sweet-modal ref="videoModal" v-on:close="yourHandlerForCloseHere">
                <iframe width="990" height="500" ref="videoModalIframe" class="desktop-element" frameborder="0"
                        allowfullscreen></iframe>
                <iframe style="margin-left: 5%;" width="330" height="315" ref="videoModalIframeMobile"
                        class="mobile-element" frameborder="0" allowfullscreen></iframe>
            </sweet-modal>

            <sweet-modal icon="error" ref="required_fields" class="padding-modal">
                <div style="padding-top: 20px">
                    <p v-for="message in errorMessage">{{ message }}</p>
                </div>
            </sweet-modal>

            <template
                    v-if="(hasRestrictArea && !allowedRestrictArea && !isAuth || !isAuth && actionLogin) && membersArea.open_by === 'popup'">
                <!-- -->
                <restrict-area ref="restrictArea" :open_by="this.membersArea.open_by"></restrict-area>
            </template>

            <sweet-modal icon="success" ref="success_send" class="padding-modal">
                {{ successSendMessage != '' ? successSendMessage : 'Message sent successful' }}
            </sweet-modal>

        </div>

        <div class="modal-loading-overlay">
            <div class="loader-spinna"></div>
        </div>

				<!-- GALLERY IMAGE -->
				<div class="gallery-overlay" v-if="galleryImage.overlay" @click="galleryImage.overlay = false">
					<img :src="galleryImage.image" />
				</div>
    </div>
</template>

<script>

	require('./components/base/editor/editor.scss')

	import PanelElement from "./components/apps/Panel/Panel.vue";
	import RestrictArea from "./components/base/restrictArea/RestrictArea";
	import {SweetModal} from 'sweet-modal-vue'
	import {isMobile, isTablet} from 'mobile-device-detect';
	import axios from 'axios';
	import {check, login, logout} from "./js/WebsiteUser";
	import {getTranslateCheetah} from "./js/Random";

	export default {
		name: 'app',
		components: {
			PanelElement,
			SweetModal,
			RestrictArea
		},
		data() {
			return {
				isAuth: false,
				actionLogin: false,
				auth: false,
				membersArea: {
					redirect: '',
					open_by: 'page',
				},
				galleryImage: {
					overlay: false,
					image: ''
				},
				hasRestrictArea: false,
				allowedRestrictArea: false,
				fixedStartPanel: 0,
				device: isTablet || isMobile ? 'mobile' : 'desktop',
				errorMessage: [],
				elements: [],
				userPopups: [],
				fontGroup: {},
				popupKeys: [],
				bgPropsPage: {},
				popupSettings: {},
				scrollPopup: false,
				isMobile: isMobile,
				isTablet: isTablet,
				cookieTypes: {
					preferences: {
						type: 'Site Preferences',
						value: 'preferences',
						description: 'These are cookies that are related to your site preferences, e.g. remembering your username, site colours, etc.'
					},
					analytics: {
						type: 'Analytics',
						value: 'analytics',
						description: 'Cookies related to site visits, browser types, etc.'
					},
					marketing: {
						type: 'Marketing',
						value: 'marketing',
						description: 'Cookies related to marketing, e.g. newsletters, social media, etc'
					}
				},
				successSendMessage: ''
			}
		},
		methods: {
			removeLogin() {
				localStorage.removeItem('login-user');
				localStorage.removeItem('login-user-all');
				localStorage.removeItem('login-user-token');

				if (this.membersArea.redirect) {
					pagesConfig.forEach(page => {
						if (+this.membersArea.redirect === +page.id) {
							window.location.href = '/' + page.url
						}
					});
				} else
					window.location.reload();

				this.setAuth();
			},

			checkLogin() {

				var login = !!(
					localStorage.getItem('login-user') && localStorage.getItem('login-user-token')
				);

				let actialPage = this.getActualPage();

				if (!actialPage)
					return;

				if (!actialPage.restrict_areas)
					return;

				if (actialPage.restrict_areas.length > 0)
					this.hasRestrictArea = true;

				if (login) {

					this.$loading.show();

					let data = {...JSON.parse(localStorage.getItem('login-user')), ...{'token': localStorage.getItem('login-user-token')}};

					if (actialPage.restrict_areas.length > 0) {
						data.page_id = actialPage.id;
						data.page_url = actialPage.url;
					}

					check(data) // check token valid e area restrita
						.then((res) => {

							if (res.data.success) {

								if (res.data.valid) {
									this.isAuth = true;

									if (actialPage.restrict_areas.length > 0 && res.data.restrict_areas) {
										this.allowedRestrictArea = !!res.data.restrict_areas.permission;
										if (!this.allowedRestrictArea && this.$refs.restrictArea) {
											this.$refs.restrictArea.changeType('not-have-permission');
										}
									}

									if (res.data.data)
										this.$refs.restrictArea.setLogin(res.data.data);
								}
							} else {
								this.$refs.restrictArea.removeLogin(res.data.data);
								this.allowedRestrictArea = false;
							}
						})
						.finally(() => {
							this.$loading.hide();
							this.setAuth();
							$('.panel-constructor').removeClass('invisible');
						});
				}
			},

			checkRestrictArea() {
				return this.getActualPage().restrict_areas.length > 0;
			},

			setAuth() {
				if (localStorage.getItem('login-user'))
					this.auth = {...JSON.parse(localStorage.getItem('login-user'))};
			},

			getActualPage() {
				let actualPage;

				try {
					if (window.location.pathname === '/') {

						actualPage = pagesConfig.find((page, index) => page !== null && (page.initial === '1'));

						if(!actualPage)
                            actualPage = pagesConfig.find((page, index) => page !== null && (page.initial === '0' && index === 0));

					} else {
						var url = window.location.pathname.replace('/', '');

						if (url)
							actualPage = pagesConfig.find((page) => page !== null && page.url.toLowerCase() === url.toLowerCase());
					}
				} catch (e) {
					console.warn('getActualPage', e);
				}

				return actualPage;
			},

			yourHandlerForCloseHere() {
				this.$refs.videoModalIframe.src = '';
				this.$refs.videoModalIframeMobile.src = '';
			},
			yourHandlerForCloseUserPopup(idPopup) {
				$('#'+idPopup+' iframe').each((idx, elem)=>{
                    $(elem).attr('data-src', $(elem).attr('src'));
                    $(elem).attr('src', null);
                });
			},
			yourHandlerForOpenUserPopup(idPopup) {
				$('#'+idPopup+' iframe').each((idx, elem)=>{
                    $(elem).attr('src', $(elem).attr('data-src'));
                });
			},

			applyFontGroup: function () {
				Object.keys(this.fontGroup).forEach(font => {
					document.body.style.setProperty('--text-family-' + font, this.fontGroup[font].family);
					document.body.style.setProperty('--text-size-' + font, this.fontGroup[font].size);
					document.body.style.setProperty('--text-size-mobile-' + font, this.fontGroup[font].sizeMobile);
					document.body.style.setProperty('--text-color-' + font, this.fontGroup[font].color);
					document.body.style.setProperty('--text-line-height-' + font, this.fontGroup[font]['line-height']);
				});
			},
			setMbossReference(pageData) {

				if (typeof pageData.mboss_reference != 'undefined' && pageData.mboss_reference != null) {
					console.log('insert mboss');


					localStorage.setItem('MAILING_BOSS_TRACKING', true);
					localStorage.setItem('MAILING_BOSS_REFERENCE',  pageData.mboss_reference);
					localStorage.setItem('MAILING_BOSS_TOKEN', pageData.mboss_token);


					var s = document.createElement("script");
					s.type = "text/javascript";
					s.src = "https://member.mailingboss.com/integration/assets/js/tracking.min.js";
					$("head").append(s);


					setTimeout(()=> {
                        if(localStorage.getItem('leadEmail') != null){
                            var options = {
                                leadEmail: localStorage.getItem('leadEmail'),
                                reference: localStorage.getItem('MAILING_BOSS_REFERENCE')
                            }
                            MailingBossTracking.init(localStorage.getItem('MAILING_BOSS_TOKEN'), options);
                        }
					},3000);
				}else{
					localStorage.removeItem('leadEmail');
					localStorage.removeItem('MAILING_BOSS_REFERENCE');
					localStorage.removeItem('MAILING_BOSS_TOKEN');
					localStorage.removeItem('MAILING_BOSS_TRACKING');
                }
			},
			applyBackground() {

				let bg = this.bgPropsPage.backgroundColor;

				if (this.$globalStoreHelpers.isValidHex(this.bgPropsPage.backgroundColor)) {
					this.bgPropsPage.backgroundColor = this.$globalStoreHelpers.hexToRGBA(this.bgPropsPage.backgroundColor);
				}

				if (this.bgPropsPage.backgroundImage !== 'none') {
					bg += ' url("' + this.bgPropsPage.backgroundImage + '")';
					bg += ' ' + this.bgPropsPage.backgroundPosition;
					bg += ' / ' + this.bgPropsPage.backgroundSize;
					bg += ' ' + this.bgPropsPage.backgroundRepeat;
					bg += ' ' + this.bgPropsPage.backgroundOrigin;
				}


				document.body.style.setProperty('--bg-page', bg);
			},

			applyPopups() {

				class EventHandlerClass {
					constructor() {
						this.functionMap = {};
					}

					addEventListener(event, func) {
						this.functionMap[event] = func;
						document.addEventListener(event.split('.')[0], this.functionMap[event]);
					}

					removeEventListener(event) {
						document.removeEventListener(event.split('.')[0], this.functionMap[event]);
						delete this.functionMap[event];
					}
				}

				const EventHandler = new EventHandlerClass();

				let vm = this;

				this.userPopups.forEach(popup => {
					// if(is_desktop)
					let $popup = this.isMobile ? this.popupSettings.mobile : this.popupSettings.desktop;


					if ($popup.popup_id == popup.id) {
						if ($popup.type === 'time') {
							setTimeout(function () {
								vm.$refs['popup' + popup.id][0].open();

							}, ((parseInt($popup.min * 60)) + parseInt($popup.sec)) * 1000)
						}
						if ($popup.type === 'scroll') {

							var scrollListener = function () {
								function showPosition(elm) {
									let parent = elm.parentNode,
										pos = (elm.scrollTop || parent.scrollTop) / (parent.scrollHeight - parent.clientHeight) * 100;

									return parseInt(pos);
								}

								let pos = showPosition(document.getElementById('editor-content'));
								console.log(pos, $popup.scroll);
								if (pos >= $popup.scroll && !vm.scrollPopup) {
									vm.$refs['popup' + popup.id][0].open();

									vm.scrollPopup = true;
								}
							};

							document.addEventListener('scroll', scrollListener, true /*Capture event*/);
						}
						if ($popup.type === 'exit') {
							EventHandler.addEventListener("mouseout.popup", evt => {
								if (evt.toElement === null && evt.relatedTarget === null) {
									vm.$refs['popup' + popup.id][0].open();

									EventHandler.removeEventListener("mouseout.popup", () => {
									});
								}
							});
						}
					}
				})
			},

			printScripts(scripts) {

				if (scripts.indexOf('marketing') > -1) {
					if (typeof layoutScriptsFb !== 'undefined') {
						try {
							$(layoutScriptsFb).appendTo($("head"));
						} catch (e) {
							console.log('broken layoutScriptsFb')
						}
					}
				}
				if (scripts.indexOf('analytics') > -1) {
					if (typeof layoutScriptsGa !== 'undefined') {
						try {
							$(layoutScriptsGa).appendTo($("head"));
						} catch (e) {
							console.log('broken layoutScriptsGa')
						}
					}
				}
				if (scripts.indexOf('necessary') > -1) {
					if (typeof layoutScripts !== 'undefined') {
						try {
							$(layoutScripts).appendTo($("head"));
						} catch (e) {
							console.log('broken layoutScripts')
						}
					}
					if (typeof pageScripts !== 'undefined') {
						try {
							$(pageScripts).appendTo($("head"));
						} catch (e) {
							console.log('broken pageScripts')
						}
					}
				}


				if (typeof OPTIONS_INIT_SITE !== 'undefined' &&
					typeof OPTIONS_INIT_SITE.options !== 'undefined' &&
					typeof OPTIONS_INIT_SITE.options.crmEnable !== 'undefined' &&
					OPTIONS_INIT_SITE.options.crmEnable === '1'
				) {

					var script = document.createElement("script");
					script.innerHTML = "(function({d=document,s='script',id='bacrmtrk', cKey, oKey}){\n" +
						"    let n, p = d.getElementsByTagName(s)[0];\n" +
						"    if (d.getElementById(id)) {return;}\n" +
						"    n = d.createElement(s); n.id = id;\n" +
						"    n.src = \"https://crm-api.eb4us.com/js/tracking.min.js\";\n" +
						"    n.onload = function(){__baCRMTracking.init({cKey, oKey})}\n" +
						"    p.parentNode.insertBefore(n, p);\n" +
						"  }({}));";
					document.head.appendChild(script);
				}
			},

			getCookie(cname) {
				var name = cname + "=";
				var decodedCookie = decodeURIComponent(document.cookie);
				var ca = decodedCookie.split(';');
				for (var i = 0; i < ca.length; i++) {
					var c = ca[i];
					while (c.charAt(0) == ' ') {
						c = c.substring(1);
					}
					if (c.indexOf(name) == 0) {
						return c.substring(name.length, c.length);
					}
				}
				return "";
			},

			setLang() {

				try {
					var lang = false;
					var i18n = this.$i18n;

					if (typeof OPTIONS_INIT_SITE !== 'undefined' && typeof OPTIONS_INIT_SITE.options !== 'undefined' &&
						typeof OPTIONS_INIT_SITE.options.lang !== 'undefined') {
						lang = OPTIONS_INIT_SITE.options.lang;
					}

					if (lang && lang !== 'en_US') {

						getTranslateCheetah(lang)
							.then(response => {
								if (response.data.success) {
									var _translations = false;
									if (window.editorTranslate && window.editorTranslate['en_US']) {
										_translations = {
											...window.editorTranslate['en_US'],
											...response.data.data
										};
									} else _translations = response.data.data;

									i18n.setLocaleMessage(lang, _translations);

									i18n.locale = lang;
								}
							})
							.catch(error => {
								console.error(error);
							});
					}
				} catch (e) {
					console.warn(e);
				}
			},

			setBannerFree() {

				let vm = this;
				if (
					typeof OPTIONS_INIT_SITE !== 'undefined' &&
					typeof OPTIONS_INIT_SITE.options !== 'undefined' &&
					typeof OPTIONS_INIT_SITE.options.id_usuario_omb10 !== 'undefined'
				) {


					axios.get('https://cheetah-api.builderall.com/get-plan/' + OPTIONS_INIT_SITE.options.id_usuario_omb10)
						.then((res) => {

							if (res.data.data.is_free == '1') {

								$('body').addClass('free-website');
								let bannerFree = $('<div>').addClass('banner-free w-100').appendTo('body');

								$('<small>').text(vm.$t('banner-free-first-text')).addClass('banner-free-first-text').appendTo(bannerFree);
								$('<small>').text(vm.$t('banner-free-second-text')).addClass('banner-free-second-text').appendTo(bannerFree);
								$('<img>').attr('src', 'https://builderall.com/franquias/2/73748/editor-html/3589641.png').addClass('banner-free-img').appendTo(bannerFree);
								$('<small>').text(vm.$t('banner-free-third-text')).addClass('banner-free-third-text').appendTo(bannerFree);
								$('<button>')
									.text(vm.$t('banner-free-btn-text'))
									.on('click', () => {
										window.open('https://builderall.com/free#aid=' + res.data.data.aid);
									})
									.addClass('btn-banner-free')
									.appendTo(bannerFree);
							}
						})

				}
			},

			redirectAid(link) {

				if (link.type === 'web' && link.value !== '') {

					const aid = OPTIONS_INIT_SITE.options.id_office_user
						? `#aid=${OPTIONS_INIT_SITE.options.id_office_user}`
						: window.aid_office

					if (link.target === '_blank') {
						return window.open(link.value + aid, '_blank');
					}

					window.location.href = link.value + aid
				} else {
					pagesConfig.forEach(page => {
						if (link.valueID == page.id) {

							const url = window.aid_office
								? page.url + window.aid_office
								: page.url

							if (link.target === '_blank') {
								return window.open('/' + url, '_blank');
							}

							window.location.href = '/' + url
						}
					});
				}
			}

		},
		mounted() {

			this.checkLogin();
			this.setLang();

			$('.seo-power-texts').css({'display': 'none'});

			let vm = this;

			if (typeof gdprSettings !== 'undefined' && gdprSettings !== false && gdprSettings.active) {


				if (vm.getCookie('cookieControl')) {
					vm.printScripts(['necessary']);
					vm.printScripts($.fn.ihavecookies.cookie())
				}

				if (this.$globalStoreHelpers.isValidHex(gdprSettings.backgroundColor)) {
					gdprSettings.backgroundColor = this.$globalStoreHelpers.hexToRGBA(gdprSettings.backgroundColor);
				}
				if (this.$globalStoreHelpers.isValidHex(gdprSettings.colorTitle)) {
					gdprSettings.colorTitle = this.$globalStoreHelpers.hexToRGBA(gdprSettings.colorTitle);
				}
				if (this.$globalStoreHelpers.isValidHex(gdprSettings.colorParagraph)) {
					gdprSettings.colorParagraph = this.$globalStoreHelpers.hexToRGBA(gdprSettings.colorParagraph);
				}
				if (this.$globalStoreHelpers.isValidHex(gdprSettings.colorLink)) {
					gdprSettings.colorLink = this.$globalStoreHelpers.hexToRGBA(gdprSettings.colorLink);
				}
				if (this.$globalStoreHelpers.isValidHex(gdprSettings.buttonBackground)) {
					gdprSettings.buttonBackground = this.$globalStoreHelpers.hexToRGBA(gdprSettings.buttonBackground);
				}
				if (this.$globalStoreHelpers.isValidHex(gdprSettings.buttonColor)) {
					gdprSettings.buttonColor = this.$globalStoreHelpers.hexToRGBA(gdprSettings.buttonColor);
				}
				if (this.$globalStoreHelpers.isValidHex(gdprSettings.buttonAdvBackground)) {
					gdprSettings.buttonAdvBackground = this.$globalStoreHelpers.hexToRGBA(gdprSettings.buttonAdvBackground);
				}
				if (this.$globalStoreHelpers.isValidHex(gdprSettings.buttonAdvColor)) {
					gdprSettings.buttonAdvColor = this.$globalStoreHelpers.hexToRGBA(gdprSettings.buttonAdvColor);
				}

				document.body.style.setProperty('--backgroundColor', gdprSettings.backgroundColor);
				document.body.style.setProperty('--colorTitle', gdprSettings.colorTitle);
				document.body.style.setProperty('--colorParagraph', gdprSettings.colorParagraph);
				document.body.style.setProperty('--colorLink', gdprSettings.colorLink);
				document.body.style.setProperty('--buttonBackground', gdprSettings.buttonBackground);
				document.body.style.setProperty('--buttonColor', gdprSettings.buttonColor);
				document.body.style.setProperty('--buttonAdvBackground', gdprSettings.buttonAdvBackground);
				document.body.style.setProperty('--buttonAdvColor', gdprSettings.buttonAdvColor);

				vm.cookieTypes['preferences'].type = gdprSettings['cookieTypes.preferences.type'];
				vm.cookieTypes['preferences'].description = gdprSettings['cookieTypes.preferences.description'];

				vm.cookieTypes['analytics'].type = gdprSettings['cookieTypes.analytics.type'];
				vm.cookieTypes['analytics'].description = gdprSettings['cookieTypes.analytics.description'];

				vm.cookieTypes['marketing'].type = gdprSettings['cookieTypes.marketing.type'];
				vm.cookieTypes['marketing'].description = gdprSettings['cookieTypes.marketing.description'];


				$('.panel-constructor').ihavecookies({
					title: gdprSettings.title,
					message: gdprSettings.message,
					expires: gdprSettings.expires,
					cookieTypes: vm.cookieTypes,
					link: gdprSettings.link,
					moreInfoLabel: gdprSettings.moreInfoLabel,
					acceptBtnLabel: gdprSettings.acceptBtnLabel,
					advancedBtnLabel: gdprSettings.advancedBtnLabel,
					uncheckBoxes: false,
					cookieTypesTitle: gdprSettings.cookieTypesTitle,
					fixedCookieTypeLabel: gdprSettings.fixedCookieTypeLabel,
					fixedCookieTypeDesc: gdprSettings.fixedCookieTypeDesc,
					onAccept: function () {
						if (vm.getCookie('cookieControl')) {
							vm.printScripts(['necessary']);
							vm.printScripts($.fn.ihavecookies.cookie())
						}
					},

				});

				if (typeof gdprSettings.position === 'undefined' || gdprSettings.position === '') {
					gdprSettings.position = 'bottom-right';
				}

				setTimeout(function () {
					$('#gdpr-cookie-message').addClass(gdprSettings.position);
					$('#gdpr-cookie-advanced').on('click', function () {
						setTimeout(function () {
							$('#gdpr-cookietype-analytics').prop('checked', true);
							$('#gdpr-cookietype-preferences').prop('checked', true);
							$('#gdpr-cookietype-marketing').prop('checked', true);
						}, 1000);
					});
				}, 2000);

			} else {
				vm.printScripts(['necessary', 'marketing', 'preferences', 'analytics']);
			}


			var query = location.hash;


			var hasValue = false;
			var originalValue = 0;

			if (typeof OPTIONS_INIT_SITE !== 'undefined') {
				hasValue = true;
				originalValue = OPTIONS_INIT_SITE.options;
			}

			if (query != '') {
				if (query.indexOf('aid') >= 0) {
					var aid = query.split('&')[0];
					window.aid_office = aid;
					let OPTIONS_INIT_SITE = {};
					OPTIONS_INIT_SITE.options = {};
					OPTIONS_INIT_SITE.options.dominio_original = window.location.host.toLocaleLowerCase();
					OPTIONS_INIT_SITE.options.domain = window.location.host.toLocaleLowerCase();

					if (hasValue) {
						OPTIONS_INIT_SITE.options = originalValue
					} else {
						OPTIONS_INIT_SITE.options.lang = 'en_US';
					}


					window.OPTIONS_INIT_SITE = OPTIONS_INIT_SITE

// if (!hasValue) {


					var date = new Date(), current_hour = date.getTime();

					if (typeof isFunnel === 'undefined') {

						var script = document.createElement('script');

						script.setAttribute('src', 'https://office.builderall.com/scripts/pixel/pixel-bundle.js?v=' + current_hour);

						document.head.appendChild(script);


						var script2 = document.createElement('script');

						script2.setAttribute('src', 'https://office.builderall.com/scripts/funis/complements.js?v=' + current_hour);

						document.head.appendChild(script2);

					}


				}
			}

			if (
				typeof OPTIONS_INIT_SITE !== 'undefined' &&
				typeof OPTIONS_INIT_SITE.options !== 'undefined' &&
				typeof OPTIONS_INIT_SITE.options.id_office_user !== 'undefined'
			) {
				axios.get('https://www.omb11.com/get/pixel-isolated?aid=' + OPTIONS_INIT_SITE.options.id_office_user)
					.then((res) => {
						$("#getfranchiseScript").empty();
						$("#getfranchiseScript").css({display: 'none'}).html(res.data);
					})
			}


			this.$root.$on('logoutWebsiteUser', () => {

				this.$loading.show();

				let data = {...JSON.parse(localStorage.getItem('login-user')), ...{'token': localStorage.getItem('login-user-token')}};

				if (!data.token) {
					this.$loading.hide();
					this.removeLogin();
					return;
				}

				logout(data)
					.then((res) => {
						if (res.data.success) {
							this.removeLogin();
						}
					})
					.catch(error => {
						console.warn(error);
					})
					.finally(() => {
						this.$loading.hide();
					});
			});

			this.$root.$on('loginWebsiteUser', () => {

				this.actionLogin = true;
				this.$nextTick(() => {
					this.$refs.restrictArea.changeType('login');
				});
			});

			this.$root.$on('setFixedStartPanel', (val) => {
				this.fixedStartPanel = val;

			});

			this.$root.$on('linkAction', (link) => {

				console.log(link);

				function validURL(str) {
					var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
						'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
						'((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
						'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
						'(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
						'(\\#[-a-z\\d_]*)?$','i'); // fragment locator
					return !!pattern.test(str);
				}


				if (
					typeof OPTIONS_INIT_SITE !== 'undefined' &&
					!!OPTIONS_INIT_SITE.options.id_office_user && ['page', 'web'].includes(link.type) ||
					!!window.aid_office && ['page', 'web'].includes(link.type)
				) {
					return this.redirectAid(link)
				}

				switch (link.type) {

					case 'web' : {

						// if (link.value !== '' && validURL(link.target)) {
						if (link.value !== '' ) {
							if (link.target === '_blank') {
								window.open(link.value, '_blank');
							} else {
								window.location.href = link.value
							}
						}
						break;
					}
					case 'page' : {


						pagesConfig.forEach(page => {
							if (link.valueID == page.id) {
								if (link.target === '_blank') {
									window.open('/' + page.url, '_blank');
								} else {
									window.location.href = '/' + page.url
								}
							}
						});
						break;
					}
					case 'anchor' : {
						let pageAnchor = {};
						let anchorName = '';

						pagesConfig.forEach(page => {

							if (typeof page !== 'undefined' && typeof page.configs !== 'undefined') {
								page.configs.forEach(config => {
									if (config.key === 'anchors') {
										let anchors = JSON.parse(config.value);
										if (typeof anchors[link.valueID] !== 'undefined') {
											pageAnchor = page;
											anchorName = anchors[link.valueID];
										}
									}
								});
							}
						});

						if (anchorName !== '')
							window.location.href = '/' + pageAnchor.url + '#' + anchorName;

						break;
					}
					case 'newAnchor' : {
						let pageAnchor = {};
						let anchorName = '';

                        let linkValue = link.valueID.split('-');

						pagesConfig.forEach(page => {

							if (typeof page !== 'undefined' && page.id == linkValue[0] && typeof page.configs !== 'undefined') {
								page.configs.forEach(config => {
									if (config.key === 'anchors') {
										let anchors = JSON.parse(config.value);
										if (typeof anchors[linkValue[1]] !== 'undefined') {
											pageAnchor = page;
											anchorName = anchors[linkValue[1]];
										}
									}
								});
							}
						});

						if (anchorName !== '')
							window.location.href = '/' + pageAnchor.url + '#' + anchorName;

						break;
					}

					case 'popup' : {
						let vm = this;

						if (
							typeof OPTIONS_INIT_SITE !== 'undefined' &&
							typeof OPTIONS_INIT_SITE.options !== 'undefined' &&
							typeof OPTIONS_INIT_SITE.options.id_office_user !== 'undefined'
						) {
							var date = new Date(),
								current_hour = date.getTime();

							var script = document.createElement('script');

							script.setAttribute('src', 'https://office.builderall.com/scripts/pixel/pixel-bundle.js?v=' + current_hour);

							document.head.appendChild(script);
						}


						this.userPopups.forEach(popup => {
							if (link.valueID == popup.id) {
								vm.$refs['popup' + popup.id][0].open();
							}
						})
						break;
					}
					case 'video' : {
						if (link.value !== '') {

							this.$refs.videoModalIframe.src = link.value;
							this.$refs.videoModalIframeMobile.src = link.value;
							this.$refs.videoModal.open();
						}

						break;
					}

					case 'supercheckout': {
						window.open(link.value, "_blank");
						break;
					}

					case 'telefone': {
						const { tel, telOpenAs } = link

						if(telOpenAs === 'call')
							document.location.href = `tel:${tel}`;

						if(telOpenAs === 'sms')
							document.location.href = `sms:${tel}`;

						if(telOpenAs === 'whatsapp')
							document.location.href= `https://api.whatsapp.com/send?phone=${tel}`
						break;
					}

					case 'download' : {
						if (link.value !== '') {
							let url = "https://storage.builderall.com" + link.value.src;


							axios.get(url, {
								responseType: "blob"
							})
								.then(response => {

									const urlData = window.URL.createObjectURL(new Blob([response.data]));
									const linkA = document.createElement('a');
									linkA.href = urlData;
									linkA.setAttribute('download', link.value.name + '.' + link.value.src.split('.').pop()); //or any other extension
									document.body.appendChild(linkA);
									linkA.click();

								})
								.catch(err => {
									var linkBtn = document.createElement("a");
									linkBtn.download = link.value.name;
									linkBtn.target = '_blank';
									linkBtn.href = url;
									linkBtn.click();
								});
						}
						break;
					}

					case 'restrict':

						this.membersArea.redirect = link.value.redirect;
						this.membersArea.open_by = 'popup';

						if (!this.isAuth && link.value.action !== 'logout') {
							this.actionLogin = true;

							this.$nextTick(() => {
								this.$refs.restrictArea.setRedirect(link.value.redirect);
								this.$refs.restrictArea.setAreas(link.value.areas);
								this.$refs.restrictArea.changeType(link.value.action);

								this.$refs.restrictArea.openModal();
							});

						} else if (this.isAuth && link.value.action === 'logout') {
							this.$root.$emit('logoutWebsiteUser');
						} else {

							if (link.value.redirect) {
								pagesConfig.forEach(page => {
									if (+link.value.redirect === +page.id) {
										window.location.href = '/' + page.url
									}
								});
							} else
								window.location.reload();
						}

						break;
				}
			});

			this.$root.$on('errorMessagePopup', (errors) => {
				this.errorMessage = errors;
				this.$refs.required_fields.open();
			});
			this.$root.$on('successMessagePopup', (message) => {
				this.successSendMessage = message;
				this.$refs.success_send.open();
			});

			//Show image url
			this.$root.$on('galleryShowImageUrl', (open, url) => {
				this.galleryImage.overlay = open;
				this.galleryImage.image = url;
			});

			this.$root.$on('applyAnimation', (vm, defaultClass) => {
//clean and restore default classes
				vm.$el.className = '';
				$(vm.$el).off(".animation");
				vm.$el.classList.add(defaultClass);

//prep;
				let animation = vm.internal_config.animation.in;
				if (animation.effect.indexOf('In') !== -1 && ['time', 'scroll'].includes(animation.action)) {
					vm.$el.classList.add('invisible');
				}

//apply
				let infinite = animation.infinite === true ? vm.$el.classList.add('infinite') : '';
				vm.$el.classList.add(animation.speed);

//apply time
				switch (animation.action) {
					case 'time':
						setTimeout(function () {
							vm.$el.classList.remove('invisible');
							vm.$el.classList.add(animation.effect, 'animated');
						}, animation.time * 1000);
						break;
					case 'click':
						$(vm.$el).on('click.animation', () => {
							vm.$el.classList.remove('invisible');
							vm.$el.classList.add(animation.effect, 'animated');
							if (!infinite) {
								vm.$el.addEventListener('animationend', function () {
									vm.$root.$emit('applyAnimation', vm, defaultClass);
								});
							}
						});
						break;
					case 'hover':
						$(vm.$el).on('mouseover.animation', () => {
							vm.$el.classList.remove('invisible');
							vm.$el.classList.add(animation.effect, 'animated');
							if (!infinite) {
								vm.$el.addEventListener('animationend', function () {
									vm.$root.$emit('applyAnimation', vm, defaultClass);
								});
							}
						});
						break;
					case 'scroll':

						let element = document.getElementById(vm.$el.id),
							bodyRect = document.body.getBoundingClientRect(),
							elemRect = element.getBoundingClientRect(),
							offset = parseFloat(vm.internal_config.top) - bodyRect.top;

                        if (window.innerHeight >= offset) {
                            window.addEventListener('load', function () {
                                vm.$el.classList.remove('invisible');
                                vm.$el.classList.add(animation.effect, 'animated');
                            });
                        }

						document.addEventListener('scroll', function () {
							if (document.getElementById('app').scrollTop + window.innerHeight >= offset) {
								// console.log('aplicou');
								vm.$el.classList.remove('invisible');
								vm.$el.classList.add(animation.effect, 'animated');
							}
						}, true /*Capture event*/);

						break;
				}
			})
			let uri = window.location.search.substring(1);
			let params = new URLSearchParams(uri);

			if (typeof config === 'undefined' || config === '') {
				axios.get(window.location.origin = '/cheetah/publish')
					.then((res => {
						if (res.data === 'published') {
							location.reload();
						}
					}))
			}

			this.elements = config;

			if (typeof popupConst !== 'undefined') {
				this.userPopups = popupConst;

			}
			this.fontGroup = fontConfig;

// this.popupKeys = Object.keys(popupConst);

			this.applyFontGroup();

			if (window.location.pathname === '/') {

				let actualPage;

				try {
					pagesConfig.forEach((page) => {

						if (page !== null && page.initial === '1') {
							actualPage = page;
						}
					})
				} catch (e) {

				}

				if (typeof actualPage !== 'undefined' && typeof actualPage.configs !== 'undefined') {

					this.setMbossReference(actualPage);
					let pageConfig = actualPage.configs;
					Object.keys(pageConfig).forEach((idx) => {
						let config = pageConfig[idx];
						if (config.key === "bgPropsPage") {
							this.bgPropsPage = JSON.parse(config.value)
							this.applyBackground();
						}
						if (config.key === "popupSettings") {
							this.popupSettings = JSON.parse(config.value)
							this.applyPopups();
						}
					})

				}

			} else {

				var url = window.location.pathname.replace('/', '');

				var pageConfig = false;
				try {
					pagesConfig.forEach(page => {
						if (page.url.toLowerCase() == url.toLowerCase()) {
							pageConfig = page;
						}
					});

//find 404 page
					if (!pageConfig) {
						pagesConfig.forEach(page => {
							if (page.url == '404') {
								pageConfig = page;
							}
						});
					}

				} catch (e) {

				}

				if (typeof pageConfig !== 'undefined' && pageConfig !== false && pageConfig.configs !== null) {

					this.setMbossReference(pageConfig);

					pageConfig.configs.forEach((config) => {
						if (config.key === "bgPropsPage") {
							this.bgPropsPage = JSON.parse(config.value);
							this.applyBackground();

						}
						if (config.key === "popupSettings") {
							this.popupSettings = JSON.parse(config.value);
							this.applyPopups();
						}
					})

				}

			}

			let hash = window.location.hash.substr(1);
			if (hash !== '') {
				setTimeout(function () {
					document.getElementById(hash).scrollIntoView({behavior: 'smooth'});
				}, 2000)
			}


			this.applyBackground();

			this.$nextTick(() => {


				let $siteBuilderPanel = $('.sitebuilder-element-panel');
				try {

					let allFonts = document.querySelectorAll('font')

					for (var i = 0, max = allFonts.length; i < max; i++) {
						allFonts[i].style['-webkit-text-fill-color'] = allFonts[i].getAttribute('color');
					}
					let all = document.querySelectorAll('[element="TextComponent"] span');

					for (var i = 0, max = all.length; i < max; i++) {
						all[i].style['-webkit-text-fill-color'] = all[i].style.color;
					}
					all.forEach((el) => {
						if (el.style.lineHeight != '') {
							el.classList.add('line-height-aqui');
						}
					})
					if (/Edge/.test(navigator.userAgent)) {
						$('body').addClass('shit-ie');
					}


					if ($('[data-fixed="true"]').length > 0) {
						$siteBuilderPanel.get(1).style.marginTop = vm.fixedStartPanel;
					} else {
						$siteBuilderPanel.get(1).classList.add('remove-margin-top')
					}

					if ($('[data-fixed-mobile="true"]').length > 0) {
						$siteBuilderPanel.get(1).style.marginTop = vm.fixedStartPanel;
					} else {
						$siteBuilderPanel.get(1).classList.add('remove-margin-top-mobile')
					}
				} catch (e) {

				}

				$('.panel-constructor').removeClass('invisible');
				this.setAuth();
				this.setBannerFree();
			})


			axios.get('/cheetah/version')
				.then(res => {
					console.log(res);
				});

			var width = window.innerWidth;

			function resizePublish(force) {
				if (width !== window.innerWidth || force) {
					width = window.innerWidth;

					if (vm.isMobile || vm.isTablet) {
						if (!(window.innerHeight > window.innerWidth) && vm.isTablet) {
							vm.device = 'desktop';
						} else {
							vm.device = 'mobile';
						}

					} else {
						if (width <= 801) {
							vm.device = 'mobile';
						} else {
							vm.device = 'desktop';
						}

					}

				}
			}
			setTimeout(()=>{
			    resizePublish(true);
            },2000);

			window.addEventListener('resize', function () {
				resizePublish(false);
			});

		}


	}
</script>

<style scoped>
    .panel-constructor.invisible-bg {
        background-color: #ffffff00 !important;
        visibility: visible !important;
    }
</style>
<style lang="scss">

    html {
        overflow: hidden;
    }

    body.free-website {
        margin-top: 50px;
    }

    .padding-modal .sweet-content {
        padding-top: 30px !important;
        padding-bottom: 30px !important;
    }

    .banner-free {
        position: fixed;
        height: 50px !important;
        width: 100%;
        top: 0;
        text-align: center;
        z-index: 99999;
        padding-top: 5px;
        font-family: Muli, sans-serif;

        background: #FFFFFF;
        box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 4px;

        .banner-free-first-text,
        .banner-free-second-text,
        .banner-free-third-text {
            color: #000000;
            margin-right: 5px;
        }

        .banner-free-second-text {
            color: #882cfd;
        }

        .banner-free-img {
            width: 110px;
        }

        .btn-banner-free {
            width: 160px;
            height: 40px;
            background: #7e1afd;
            border-radius: 8px;
            font-style: normal;
            font-weight: 700;
            font-size: 14px;
            line-height: 30px;
            color: #fff;
        }
    }

    @media (max-width: 800px) {
        .banner-free {
            font-size: 12px;
            padding-top: 0;

            .btn-banner-free {
                font-size: 12px;
            }

            .banner-free-third-text {
                display: none;
            }
        }
    }

    @media (max-width: 600px) {
        .banner-free {
            .btn-banner-free {
                position: absolute;
                left: calc(50% - 80px);
                top: 30px;
            }
        }
    }

    @media (max-width: 600px) {
        .banner-free {
            .banner-free-img {
                display: none;
            }
        }
    }


    .invisible {
        visibility: hidden;
    }

    [data-device="desktop"] {
        [data-fixed="true"] {
            position: fixed;
            left: 0;
            width: 100%;
            top: 0;
            z-index: 10000;
        }
        .sitebuilder-element-container{
            max-width: initial !important;
        }
    }

    [data-device="mobile"] {
        [data-fixed-mobile="true"] {
            position: fixed;
            width: 100%;
            top: 0;
            z-index: 10000;
        }
    }

    body.free-website [data-fixed="true"] {
        top: 60px;

    }

    [data-device="desktop"] .remove-margin-top,
    [data-device="mobile"] .remove-margin-top-mobile {
        margin-top: 0 !important;
    }

    /* Cookie Dialog */
    #gdpr-cookie-message {
        position: fixed;

        max-width: 375px;
        background-color: var(--backgroundColor);
        padding: 20px;
        border-radius: 5px;
        box-shadow: 0 6px 6px rgba(0, 0, 0, 0.25);
        font-family: 'Roboto', sans-serif;
        z-index: 1000;

        &.bottom-right {
            right: 30px;
            bottom: 30px;
        }

        &.top-right {
            right: 30px;
            top: 30px;
        }

        &.bottom-left {
            left: 30px;
            bottom: 30px;
        }

        &.top-left {
            left: 30px;
            top: 30px;
        }

        &.full-bottom {
            bottom: 0;
            left: 0;
            max-width: none;
            width: 100%;

            * {
                max-width: 500px;
                margin: 5px auto;
            }
        }

        &.full-top {
            top: 0;
            left: 0;
            max-width: none;
            width: 100%;
            bottom: unset;

            * {
                max-width: 500px;
                margin: 5px auto;
            }
        }

        &.center-center {
            top: calc(50% - 90px);
            left: calc(50% - 187px);
        }

        h4 {
            color: var(--colorTitle);
            font-family: 'Roboto', sans-serif;
            font-size: 18px;
            font-weight: 500;
            margin-bottom: 10px;
        }

        h5 {
            color: var(--colorTitle);
            font-family: 'Roboto', sans-serif;
            font-size: 15px;
            font-weight: 500;
            margin-bottom: 10px;
        }

        input[type="checkbox"] {
            float: none;
            margin-top: 0;
            margin-right: 5px;
        }

        p, ul {
            color: var(--colorParagraph);
            font-size: 15px;
            line-height: 1.5em;

            &:last-child {
                margin-bottom: 0;
                text-align: right;
                padding-inline-start: 0 !important;
            }
        }

        li {
            width: 49%;
            display: inline-block;
            text-align: left;
        }

        a {
            color: var(--colorLink);
            text-decoration: none;
            font-size: 15px;
            padding-bottom: 2px;
            border-bottom: 1px dotted rgba(255, 255, 255, 0.75);
            transition: all 0.3s ease-in;

            &:hover {
                color: white;
                border-bottom-color: var(--colorLink);
                transition: all 0.3s ease-in;
            }
        }

        button {
            border: none;
            background: var(--buttonBackground);
            color: var(--buttonColor);
            font-family: 'Roboto', sans-serif;
            font-size: 15px;
            padding: 7px;
            border-radius: 3px;
            margin-left: 15px;
            cursor: pointer;
            transition: all 0.3s ease-in;
            max-width: 50% !important;

            &:hover {
                background: var(--buttonColor);
                color: var(--buttonBackground);
                transition: all 0.3s ease-in;
            }

            &:disabled {
                opacity: 0.3;
            }
        }
    }

    button#gdpr-cookie-advanced {
        background: var(--buttonAdvBackground);
        color: var(--buttonAdvColor);
        float: left;
    }

    .link-action {
        cursor: pointer;
    }

    [data-device="mobile"]{

        .desktop-element {
            display: none !important;
        }

        .mobile-element {
            display: block !important;
        }

        .sitebuilder-element-container {
            position: relative !important;
            left: 0 !important;
            top: 0 !important;
            height: auto !important;
            width: auto !important;
            padding-top: 15px;
            padding-bottom: 15px;
        }

        .container-fluid {
            height: auto !important;
        }

        [element="ImageComponent"] img {
            width: 100% !important;
            max-width: 400px;
            height: auto !important;

        }

        [element="ImageComponent"] {

            text-align: center;
        }

    }

    [data-device="desktop"]{

        .desktop-element {
            display: block !important;
        }

        .mobile-element {
            display: none !important;
        }

    }

    .modal-loading-overlay {
        display: none;
        position: fixed;
        z-index: 90002;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: #FFF;
    }

    body.loading .modal-loading-overlay {
        overflow: hidden;
    }

    body.loading .modal-loading-overlay {
        display: block;
    }

    .loader-spinna {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        overflow: hidden;
        z-index: 2;
        background-color: rgba(2, 22, 43, 0.44);
        position: absolute;
        top: 50%;
        left: calc(50% - 25px);
    }

    .loader-spinna:before, .loader-spinna:after {
        content: '';
        position: absolute;
        display: inline-block;
        width: 50px;
        height: 50px;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        border-radius: 50%;
        z-index: 1;
    }

    .loader-spinna:before {
        border: 5px dotted rgba(8, 30, 63, 0);
        box-shadow: inset 0 0 0 3em #ffffff;
    }

    .loader-spinna:after {
        z-index: 0;
        border-width: 10px;
        border-style: solid;
        -o-border-image: linear-gradient(to bottom, #858585 0%, transparent 100%);
        border-image: linear-gradient(to bottom, rgba(40, 40, 40, 0.98) 0%, transparent 100%);
        border-image-slice: 0 0 0 20;
        -webkit-animation: spinnaRot 1s infinite linear;
        animation: spinnaRot 1s infinite linear;
    }

    @-webkit-keyframes spinnaRot {
        to {
            -webkit-transform: rotate(359deg);
            transform: rotate(359deg);
        }
    }

    @keyframes spinnaRot {
        to {
            -webkit-transform: rotate(359deg);
            transform: rotate(359deg);
        }
    }

    @media (max-width: 600px) {

        .banner-free .btn-banner-free {
            position: absolute;
            left: calc(50% - 80px);
            top: 17px;
        }

        .banner-free .btn-banner-free {
            width: 140px;
            height: 30px;
            background: #7e1afd;
            border-radius: 8px;
            font-style: normal;
            font-weight: 700;
            font-size: 14px;
            line-height: 5px;
            color: #fff;
        }

    }


</style>

